import Model from './Model';

class WhatsApp extends Model {
  getId() {
    return this.attrs.id;
  }

  setId(value) {
    this.attrs.id = value;
    return this;
  }

  getToken() {
    return this.attrs.token;
  }

  setToken(value) {
    this.attrs.token = value;
    return this;
  }

   getChunkData() {
    return this.attrs.chunkData;
  }

  setChunkData(value) {
    this.attrs.chunkData = value;
    return this;
  }


  getPin() {
    return this.attrs.pin;
  }

  setPin(value) {
    this.attrs.pin = value;
    return this;
  }

  getPhoneNumberId() {
    return this.attrs.phoneNumberId;
  }

  setPhoneNumberId(value) {
    this.attrs.phoneNumberId = value;
    return this;
  }

  getWabaId() {
    return this.attrs.wabaId;
  }

  setWabaId(value) {
    this.attrs.wabaId = value;
    return this;
  }

  getBusinessId() {
    return this.attrs.businessId;
  }

  setBusinessId(value) {
    this.attrs.businessId = value;
    return this;
  }

  getOnboardingMode() {
    return this.attrs.onboardingMode;
  }

  setOnboardingMode(value) {
    this.attrs.onboardingMode = value;
    return this;
  }

  getServiceId() {
    return this.attrs.serviceId;
  }

  setServiceId(value) {
    this.attrs.serviceId = value;
    return this;
  }

  getAccessToken() {
    return this.attrs.accessToken;
  }

  setAccessToken(value) {
    this.attrs.accessToken = value;
    return this;
  }

  getWhatsappTemplate() {
    return this.attrs.whatsappTemplate;
  }

  setWhatsappTemplate(value) {
    this.attrs.whatsappTemplate = value;
    return this;
  }

  getTemplateName() {
    return this.attrs.templateName;
  }

  setTemplateName(value) {
    this.attrs.templateName = value;
    return this;
  }

  getTemplateType() {
    return this.attrs.templateType;
  }

  setTemplateType(value) {
    this.attrs.templateType = value;
    return this;
  }

  getLanguage() {
    return this.attrs.language;
  }

  setLanguage(value) {
    this.attrs.language = value;
    return this;
  }

  getTemplateEvent() {
    return this.attrs.templateEvent;
  }

  setTemplateEvent(value) {
    this.attrs.templateEvent = value;
    return this;
  }

  getTemplateHeader() {
    return this.attrs.templateHeader;
  }

  setTemplateHeader(value) {
    this.attrs.templateHeader = value;
    return this;
  }

  getTemplateFooter() {
    return this.attrs.templateFooter;
  }

  setTemplateFooter(value) {
    this.attrs.templateFooter = value;
    return this;
  }

  getTemplateBody() {
    return this.attrs.templateBody;
  }

  setTemplateBody(value) {
    this.attrs.templateBody = value;
    return this;
  }

  getIsEnable() {
    return this.attrs.isEnable;
  }

  setIsEnable(value) {
    this.attrs.isEnable = value;
    return this;
  }

  getTemplateButton() {
    return this.attrs.templateButton;
  }

  setTemplateButton(value) {
    this.attrs.templateButton = value;
    return this;
  }

  getHeaderType() {
    return this.attrs.headerType;
  }

  setHeaderType(value) {
    this.attrs.headerType = value;
    return this;
  }

  getPhoneText() {
    return this.attrs.phoneText;
  }

  setPhoneText(value) {
    this.attrs.phoneText = value;
    return this;
  }

  getPhoneNumber() {
    return this.attrs.phoneNumber;
  }

  setPhoneNumber(value) {
    this.attrs.phoneNumber = value;
    return this;
  }

  getWebsiteText() {
    return this.attrs.websiteText;
  }

  setWebsiteText(value) {
    this.attrs.websiteText = value;
    return this;
  }

  getWebsiteLink() {
    return this.attrs.websiteLink;
  }

  setWebsiteLink(value) {
    this.attrs.websiteLink = value;
    return this;
  }

  getStatus() {
    return this.attrs.status;
  }

  setStatus(value) {
    this.attrs.status = value;
    return this;
  }

  getCatalog() {
    return this.attrs.catalog;
  }

  setCatalog(value) {
    this.attrs.catalog = value;
    return this;
  }

  getCatalogButtonText() {
    return this.attrs.catalogButtonText;
  }

  setCatalogButtonText(value) {
    this.attrs.catalogButtonText = value;
    return this;
  }

  getCatalogId() {
    return this.attrs.catalogId;
  }

  setCatalogId(value) {
    this.attrs.catalogId = value;
    return this;
  }

  getCatalogName() {
    return this.attrs.catalogName;
  }

  setCatalogName(value) {
    this.attrs.catalogName = value;
    return this;
  }

  getProductId() {
    return this.attrs.productId;
  }

  setProductId(value) {
    this.attrs.productId = value;
    return this;
  }

  getVariantId() {
    return this.attrs.variantId;
  }

  setVariantId(value) {
    this.attrs.variantId = value;
    return this;
  }

  getCreatedAt() {
    return this.attrs.createdAt;
  }

  setCreatedAt(value) {
    this.attrs.createdAt = value;
    return this;
  }

  getProductCount() {
    return this.attrs.productCount;
  }

  setProductCount(value) {
    this.attrs.productCount = value;
    return this;
  }

  getAuthText() {
    return this.attrs.authText;
  }

  setAuthText(value) {
    this.attrs.authText = value;
    return this;
  }

  getInvoiceText() {
    return this.attrs.invoiceText;
  }

  setInvoiceText(value) {
    this.attrs.invoiceText = value;
    return this;
  }

  getMessageKey() {
    return this.attrs.messageKey;
  }

  setMessageKey(value) {
    this.attrs.messageKey = value;
    return this;
  }

  getActionId() {
    return this.attrs.actionId;
  }

  setActionId(value) {
    this.attrs.actionId = value;
    return this;
  }

  getButton() {
    return this.attrs.button;
  }

  setButton(value) {
    this.attrs.button = value;
    return this;
  }

  getList() {
    return this.attrs.list;
  }

  setList(value) {
    this.attrs.list = value;
    return this;
  }

  getHeader() {
    return this.attrs.header;
  }

  setHeader(value) {
    this.attrs.header = value;
    return this;
  }

  getFooter() {
    return this.attrs.footer;
  }

  setFooter(value) {
    this.attrs.footer = value;
    return this;
  }

  getBody() {
    return this.attrs.body;
  }

  setBody(value) {
    this.attrs.body = value;
    return this;
  }

  getWhatsappMedia() {
    return this.attrs.whatsappMedia;
  }

  setWhatsappMedia(value) {
    this.attrs.whatsappMedia = value;
    return this;
  }

  getMediaType() {
    return this.attrs.mediaType;
  }

  setMediaType(value) {
    this.attrs.mediaType = value;
    return this;
  }

  getCaption() {
    return this.attrs.caption;
  }

  setCaption(value) {
    this.attrs.caption = value;
    return this;
  }
  getStoreId() {
    return this.attrs.storeId;
  }

  setStoreId(value) {
    this.attrs.storeId = value;
    return this;
  }

  getIsEmbeddedSignup() {
    return this.attrs.isEmbeddedSignup;
  }

  setIsEmbeddedSignup(value) {
    this.attrs.isEmbeddedSignup = value;
    return this;
  }

  getIsHistorySync() {
    return this.attrs.isHistorySync;
  }

  setIsHistorySync(value) {
    this.attrs.isHistorySync = value;
    return this;
  }

  getIsContactSync() {
    return this.attrs.isContactSync;
  }

  setIsContactSync(value) {
    this.attrs.isContactSync = value;
    return this;
  }
}

export default WhatsApp;
